// extracted by mini-css-extract-plugin
module.exports = {"image":"post-module--image--1yMM6","date":"post-module--date--1eM4d","allBtn":"post-module--allBtn--3Zr_j","fbBtn":"post-module--fbBtn--2Usm2"};